import { render } from "./reportBillCostDetail.vue?vue&type=template&id=00946581"
import script from "./reportBillCostDetail.vue?vue&type=script&lang=js"
export * from "./reportBillCostDetail.vue?vue&type=script&lang=js"

import "./reportBillCostDetail.vue?vue&type=style&index=0&id=00946581&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__